import axios_instance from "../axios.config";

const ListApplication = async () => {
  const response = await axios_instance.get("/newadmission/get");
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const AddApplication = async (applicationData: any) => {
  try {
    const { newApplication } = applicationData;

    const payload = {
      newApplication,
    };
    const response = await axios_instance.post("/newadmission/add", payload);
    console.log(response);
    if (response?.data?.status === "SUCCESS") {
      return response?.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Error Adding New Student");
    console.log(error);
    return [];
  }
};

const UpdateApplication = async (applicationData: any) => {
  try {
    const { updatedApplication } = applicationData;

    const payload = {
      updatedApplication,
    };
    const response = await axios_instance.post("/newadmission/update", payload);
    console.log(response);
    if (response?.data?.status === "SUCCESS") {
      return response?.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Error Updating Student");
    console.log(error);
    return [];
  }
};

export { ListApplication, AddApplication, UpdateApplication };
